var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"ma-1",attrs:{"color":"primary","small":"","to":_vm.to,"min-width":"120"}},[_vm._v(_vm._s(_vm.label))])
}
var staticRenderFns = []

export { render, staticRenderFns }